// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__KqI1F","active":"Tab_active__oREgK"};